import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { coreEN } from "./localization";
import { resources as ivResources } from "iv/i18n";
import { resources as cnResources } from "cloud_numbers/i18n";
import { sharedEN } from "@ucchub/ui";

const resources = {
  en: {
    shared: sharedEN,
    core: coreEN,
    cn: cnResources.en,
    iv: ivResources.en,
  },
};

// eslint-disable-next-line import/no-named-as-default-member
i18next
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    defaultNS: "common",
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
  });

export default i18next;
